var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news"},[_c('div',{staticClass:"contents"},[_c('div',{attrs:{"id":"news"}}),_c('ContentsTitle',{attrs:{"path":_vm.getTitleNews}}),_c('div',{staticClass:"contents-main"},[_c('div',{staticClass:"contents-container"},[_c('NewsList',{attrs:{"newsList":_vm.newsList}})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }